import { Component, Input, OnInit } from '@angular/core';
import { TranslationHelper } from 'src/app/client/core/lib/translation.helper';
import { PopoverModel } from './popover.model';

@Component({
  selector: 'app-popover-content',
  templateUrl: './popover-content.component.html',
})
export class PopoverContentComponent
  extends TranslationHelper
  implements OnInit
{
  @Input() popoverInfo?: PopoverModel;
  constructor() {
    super();
  }

  ngOnInit(): void {
    if (this.popoverInfo?.prefix) {
      this.setTranslationPrefix(this.popoverInfo?.prefix);
    }
  }
}
